<div class="mat-dialog-container">
    <div class="dialog-content">
        <i class="fas fa-exclamation-triangle dialog-icon"></i>
        <p>Your session will expire in</p>
        <p class="timer"><strong>{{ displayTime }}</strong></p>
    </div>
    <div class="dialog-actions">
        <button mat-button class="confirm-button" (click)="onExtend()">
            <i class="fas fa-clock"></i> Extend
        </button>
        <button mat-button color="warn" class="cancel-button" (click)="onLogout()">
            <i class="fas fa-sign-out-alt"></i> Logout
        </button>
    </div>
</div>